'use strict';

var formValidation = require('./formValidation');

/**
 * Clean the form fields
 */
function cleanFields() {
    $('#contactUs_type').val('').trigger('focusout');
    $('#contacUs_fullName').val('').trigger('input');
    $('#contactUs_email').val('').trigger('input');
    $('#contactUs_phoneNumber').val('').trigger('input');
    $('#contactUs_message').val('').trigger('input');
    $('#recaptchaToken').val('');
}

/**
 * Call the ContactUs controller
 */
function handleSubmitForm() {
    var $form = $('.contactus-request-form');
    var url = $form.attr('action');
    var formData = $form.serialize();
    $form.parent().spinner().start();

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: formData,
        success: function (data) {
            $form.parent().spinner().stop();
            if (!data.success) {
                $('#recaptchaToken').val('');
                formValidation($form, data);
                $(document).trigger('showNotificationClient', {
                    type: 'error',
                    message: data.errorMessage,
                    cssClass: ''
                });
            } else {
                $(document).trigger('showNotificationClient', {
                    type: 'success',
                    message: data.successMessage,
                    cssClass: ''
                });
                cleanFields();

            }

        },
        error: function (err) {
            console.error(err);
            $form.parent().spinner().stop();
        }
    });
}

/**
 * Load google recaptcha script
 */
function loadScript() {
    var script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
}

/**
 * Init recaptcha
 */
function init() {
    loadScript();
    cleanFields();

    $('.contactus-request-form').on('submit', function (e) {
        e.preventDefault();
        grecaptcha.execute();
    });

    window.onRecaptchaSuccess = function (token) {
        $('body').trigger('recaptchaSuccess', token);
    };

    $('body').on('recaptchaSuccess', function (event, token) {
        $('#recaptchaToken').val(token);
        handleSubmitForm();
    });
}

module.exports = {
    init: init
};